import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  maxBreakpointQuery,
  minBreakpointQuery,
  standardColours,
  zIndexLayers,
} from '../styles';
import { Svg } from './ui';
import SearchForm from './SearchForm';
import searchIcon from '../images/search-icon.inline.svg';
import closeIcon from '../images/close-icon.inline.svg';

const StyledSearch = styled.div``;

const StyledToggle = styled.button`
  position: relative;
  border: none;
  background: none;

  ${({ display }) => {
    if (display) {
      return css`
        z-index: ${zIndexLayers.fourth};

        svg {
          path {
            fill: ${standardColours.white};
          }
        }
      `;
    } else {
      return css`
        display: none;
      `;
    }
  }}
`;

const StyledIcon = styled(Svg)`
  width: 28px;
  height: 28px;

  path {
    fill: ${standardColours.black};

    ${minBreakpointQuery.mlarge`
      fill: ${brandColours.primary}
    `}
  }
`;

const StyledFormWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zIndexLayers.third};
  display: ${({ display }) => (display ? 'block' : 'none')};
  height: 100%;
  width: 100%;
  background-color: ${brandColours.primary};

  ${maxBreakpointQuery.large`
    padding: 100px 35px 20px;
  `}

  ${minBreakpointQuery.large`
    display: ${({ display }) => (display ? 'flex' : 'none')};
    align-items: center;
  `}
`;

const StyledForm = styled(SearchForm)`
  background: none;
  border: 1px solid ${standardColours.white};
  width: 100%;

  input {
    color: ${standardColours.white};

    &::placeholder {
      color: ${standardColours.white};
    }
  }

  svg {
    path {
      fill: ${standardColours.white};
    }
  }

  ${minBreakpointQuery.large`
    max-width: 450px;
    margin: 0 auto;
  `}

  ${minBreakpointQuery.xlarge`
    max-width: 500px;
  `}
`;

const Search = ({ displaySearch, setDisplaySearch }) => (
  <StyledSearch display={displaySearch}>
    <StyledToggle
      aria-label="Open Search"
      onClick={() => setDisplaySearch(true)}
      display={!displaySearch}
    >
      <StyledIcon image={searchIcon} />
    </StyledToggle>
    <StyledToggle
      aria-label="Close Search"
      display={displaySearch}
      onClick={() => setDisplaySearch(false)}
    >
      <StyledIcon image={closeIcon} />
    </StyledToggle>
    <StyledFormWrapper display={displaySearch}>
      <StyledForm
        placeholder="Search our website..."
        displaySearch={displaySearch}
      />
    </StyledFormWrapper>
  </StyledSearch>
);

export default Search;
